<template>
  <div class="recap-element" :class="[{'white': white}, color]">
    <div class="label">
      {{ label }}
    </div>
    <h5 class="total">
      {{ total }}
    </h5>
    <div class="number">
      {{ number }}
    </div>
    <div class="color-1"></div>
    <div class="color-2"></div>
    <div class="color-3"></div>
  </div>
</template>

<script>
export default {
  name: "recap",

  props: {
    label: {
      type: String,
      required: true,
    },
    total: {
      type: String,
      required: true
    },
    number: {
      type: String,
      required: true
    },
    white: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    }

  }
}
</script>

<style scoped>

</style>